import { render } from "./PageScroller.vue?vue&type=template&id=72d4828a"
import script from "./PageScroller.vue?vue&type=script&lang=js"
export * from "./PageScroller.vue?vue&type=script&lang=js"

import "./PageScroller.vue?vue&type=style&index=0&id=72d4828a&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__